export default __webpack_public_path__ + "static/media/BCA24.469fd19c.jpg";